import { MatPaginatorIntl } from '@angular/material/paginator';

export function getTablePaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();
  paginatorIntl.itemsPerPageLabel = 'Rows per page: ';
  return paginatorIntl;
}
